import { Layout } from 'spa/components/layout'
import React from 'react'
import SubscriptionUpdate from 'spa/components/subscription/subscription_update'

const display = () => {
  return (
    <Layout fullLayout tabTitle="subscription">
      <SubscriptionUpdate />
    </Layout>
  )
}

export { display as SubscriptionDisplay }
